/* tslint:disable */
/* eslint-disable */
/**
 * Business Orchestration Layer (BOL) API
 * Business Orchestration layer (BOL) API. Public part, exposed to BOL client applications.  Glossary | Definition -- | -- <strong>Logistics Object</strong> | A resource in the BOL system that represents a business entity, such as a QuotationRequest, Quotation, or Service. Logistics Objects are managed through the BOL API and can be accessed or modified by Users based on their permissions i.e. based on their AD Entra ID roles and ACL (Access Control List) modes. <strong>Member</strong> | A data owner in the BOL system, uniquely identified by its `memberIdentifier`. Members are used to manage access control and ownership of Logistics Objects. <strong>User</strong> | A person or entity that interacts with the BOL system, typically through a client application, and beeing authenticated. Users are associated with Members and can perform actions on Logistics Objects based on their access level. User access token includes the Member identifier as part of roles claims. Each path in the API is protected by a custom role defined in AD Entra ID, and operations on Logistics Objects are protected by specific Access modes defined by members. <strong>Access Control</strong> | The mechanism by which the BOL system restricts access to API paths and resources based on the identity of the User and their associated Member. Access control is enforced through AD Entra ID roles and ACL (Access Control List) modes defined for every single Logistics Object. <strong>ACL (Access Control List)</strong> | A set of authorizations that define what actions a User can perform on a Logistics Object. The level of access granted to Users is determined by ACL modes defined in authorizations for specific Logistics Objects. ACL Modes are not directly associated with Users but rather with Members, which are the data owners of Logistics Objects. Each Logistics Object has an ACL that specifies the access modes for different Members. Members need to exist in the BOL system to be granted access to Logistics Objects. <strong>ACL Mode</strong> | The specific level of access control applied to a Logistics Object, determining what actions can be performed by Users. ACL modes are defined for each Logistics Object by `memberIdentifier` and include `READ`, `WRITE`, and `CONTROL`. Each mode includes access granted by the modes under it, so `CONTROL` includes `WRITE` and `READ`, and `WRITE` includes `READ`. <strong>Change Request</strong> | A request to modify a Logistics Object, which is processed by the BOL system. Change requests are created when a User wants to update an existing Logistics Object, and they are subject to approval and application by the system. All changes to Logistics Objects are done through change requests. This allows for a controlled and auditable process of modifications. <strong>Host</strong> | A server alias in the BOL system, used to abstract URI values internally. This allows for flexibility in the underlying infrastructure when migrating or changing server configurations. 
 *
 * The version of the OpenAPI document: 7.2.1-develop.2
 * Contact: benoit.tiers@logist-x.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ACL,
  ACLAuthorization,
  ACLAuthorizationRequest,
  ChangeRequest,
  ChangeRequestCreateRequest,
  ChangeRequestPatchRequest,
  ErrorResponse,
  EventCreateRequest,
  HumanMean,
  HumanMeanResponse,
  LogisticsObjectMetadata,
  PaginatedChangeRequests,
  PaginatedEvents,
  SearchHumanMeansRequest,
  SearchHumanMeansResponse,
} from '../models/index';
import {
    ACLFromJSON,
    ACLToJSON,
    ACLAuthorizationFromJSON,
    ACLAuthorizationToJSON,
    ACLAuthorizationRequestFromJSON,
    ACLAuthorizationRequestToJSON,
    ChangeRequestFromJSON,
    ChangeRequestToJSON,
    ChangeRequestCreateRequestFromJSON,
    ChangeRequestCreateRequestToJSON,
    ChangeRequestPatchRequestFromJSON,
    ChangeRequestPatchRequestToJSON,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    EventCreateRequestFromJSON,
    EventCreateRequestToJSON,
    HumanMeanFromJSON,
    HumanMeanToJSON,
    HumanMeanResponseFromJSON,
    HumanMeanResponseToJSON,
    LogisticsObjectMetadataFromJSON,
    LogisticsObjectMetadataToJSON,
    PaginatedChangeRequestsFromJSON,
    PaginatedChangeRequestsToJSON,
    PaginatedEventsFromJSON,
    PaginatedEventsToJSON,
    SearchHumanMeansRequestFromJSON,
    SearchHumanMeansRequestToJSON,
    SearchHumanMeansResponseFromJSON,
    SearchHumanMeansResponseToJSON,
} from '../models/index';

export interface CreateChangeRequestOnHumanMeanByIdRequest {
    humanMeanId: string;
    contentType: CreateChangeRequestOnHumanMeanByIdContentTypeEnum;
    changeRequestCreateRequest: ChangeRequestCreateRequest;
    source?: boolean;
    accept?: CreateChangeRequestOnHumanMeanByIdAcceptEnum;
    traceparent?: string;
}

export interface CreateHumanMeanRequest {
    contentType: CreateHumanMeanContentTypeEnum;
    xBOLMemberIdentifier: string;
    humanMean: HumanMean;
    id?: string;
    source?: boolean;
    accept?: CreateHumanMeanAcceptEnum;
    traceparent?: string;
    xBOLACLAuthorizations?: string;
}

export interface CreateHumanMeanEventRequest {
    humanMeanId: string;
    contentType: CreateHumanMeanEventContentTypeEnum;
    xBOLMemberIdentifier: string;
    eventCreateRequest: EventCreateRequest;
    accept?: CreateHumanMeanEventAcceptEnum;
    traceparent?: string;
}

export interface DeleteHumanMeanACLAuthorizationByMemberIdRequest {
    humanMeanId: string;
    memberId: string;
    xBOLMemberIdentifier: string;
    aclRevision?: string;
    traceparent?: string;
}

export interface DeleteHumanMeanByIdRequest {
    humanMeanId: string;
    traceparent?: string;
}

export interface DeleteHumanMeanEventByIdRequest {
    humanMeanId: string;
    eventId: string;
    xBOLMemberIdentifier: string;
    traceparent?: string;
}

export interface GetChangeRequestOnHumanMeanByIdRequest {
    humanMeanId: string;
    changeRequestId: string;
    accept?: GetChangeRequestOnHumanMeanByIdAcceptEnum;
    traceparent?: string;
}

export interface GetHumanMeanACLAuthorizationByMemberIdRequest {
    humanMeanId: string;
    memberId: string;
    at?: string;
    aclRevision?: string;
    accept?: GetHumanMeanACLAuthorizationByMemberIdAcceptEnum;
    traceparent?: string;
}

export interface GetHumanMeanACLByIdRequest {
    humanMeanId: string;
    at?: string;
    revision?: string;
    accept?: GetHumanMeanACLByIdAcceptEnum;
    traceparent?: string;
}

export interface GetHumanMeanByIdRequest {
    humanMeanId: string;
    at?: string;
    revision?: string;
    accept?: GetHumanMeanByIdAcceptEnum;
    traceparent?: string;
}

export interface GetHumanMeanEventsRequest {
    humanMeanId: string;
    limit?: number;
    offset?: number;
    startAt?: Date;
    endAt?: Date;
    code?: string;
    type?: string;
    accept?: GetHumanMeanEventsAcceptEnum;
    traceparent?: string;
}

export interface GetHumanMeanMetadataByIdRequest {
    humanMeanId: string;
    accept?: GetHumanMeanMetadataByIdAcceptEnum;
    traceparent?: string;
}

export interface ListChangeRequestsOfHumanMeanByIdRequest {
    humanMeanId: string;
    limit?: number;
    offset?: number;
    accept?: ListChangeRequestsOfHumanMeanByIdAcceptEnum;
    traceparent?: string;
}

export interface PatchHumanMeanByIdRequest {
    humanMeanId: string;
    contentType: PatchHumanMeanByIdContentTypeEnum;
    xBOLMemberIdentifier: string;
    humanMean: HumanMean;
    revision?: string;
    accept?: PatchHumanMeanByIdAcceptEnum;
    traceparent?: string;
}

export interface SearchHumanMeanGetRequest {
    id?: string;
    searchBody?: SearchHumanMeansRequest;
    accept?: SearchHumanMeanGetAcceptEnum;
    traceparent?: string;
}

export interface SearchHumanMeansPostRequest {
    contentType: SearchHumanMeansPostContentTypeEnum;
    searchHumanMeansRequest: SearchHumanMeansRequest;
    limit?: number;
    offset?: number;
    accept?: SearchHumanMeansPostAcceptEnum;
    traceparent?: string;
}

export interface UpdateChangeRequestOnHumanMeanByIdRequest {
    humanMeanId: string;
    changeRequestId: string;
    contentType: UpdateChangeRequestOnHumanMeanByIdContentTypeEnum;
    changeRequestPatchRequest: ChangeRequestPatchRequest;
    accept?: UpdateChangeRequestOnHumanMeanByIdAcceptEnum;
    traceparent?: string;
}

export interface UpdateHumanMeanByIdRequest {
    humanMeanId: string;
    contentType: UpdateHumanMeanByIdContentTypeEnum;
    xBOLMemberIdentifier: string;
    humanMean: HumanMean;
    revision?: string;
    accept?: UpdateHumanMeanByIdAcceptEnum;
    traceparent?: string;
}

export interface UpsertHumanMeanACLAuthorizationByIdRequest {
    humanMeanId: string;
    contentType: UpsertHumanMeanACLAuthorizationByIdContentTypeEnum;
    xBOLMemberIdentifier: string;
    aclRevision?: string;
    accept?: UpsertHumanMeanACLAuthorizationByIdAcceptEnum;
    traceparent?: string;
    aCLAuthorizationRequest?: ACLAuthorizationRequest;
}

/**
 * 
 */
export class LogisticsObjectsHumanMeansApi extends runtime.BaseAPI {

    /**
     * ## Description  This endpoint allows the creation of a change request on a specific HumanMean resource, identified by its `HumanMeanId`.  The change request uses the JSON Patch format as specified in [RFC 6902](https://datatracker.ietf.org/doc/html/rfc6902), enabling clients to submit a set of operations to modify the HumanMean resource.  Client uers must have the provided `requestorMemberIdentifier` as part of their own member identifiers.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Update`. - **ACL Mode**: `WRITE` mode or above is required to create a change request on a HumanMean resource.   - **Note**: The `WRITE` mode is sufficient for creating change requests, but higher modes like `CONTROL` or `Admin` can also be used.   - With `CONTROL` mode, the change request will be automatically accepted and applied, updating the HumanMean resource.   - With `WRITE` mode, the change request will be created but not applied automatically. The change request must then be accepted or rejected using the `PATCH` method on the change request resource. 
     * Create a change request on a HumanMean
     */
    async createChangeRequestOnHumanMeanByIdRaw(requestParameters: CreateChangeRequestOnHumanMeanByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ChangeRequest>> {
        if (requestParameters['humanMeanId'] == null) {
            throw new runtime.RequiredError(
                'humanMeanId',
                'Required parameter "humanMeanId" was null or undefined when calling createChangeRequestOnHumanMeanById().'
            );
        }

        if (requestParameters['contentType'] == null) {
            throw new runtime.RequiredError(
                'contentType',
                'Required parameter "contentType" was null or undefined when calling createChangeRequestOnHumanMeanById().'
            );
        }

        if (requestParameters['changeRequestCreateRequest'] == null) {
            throw new runtime.RequiredError(
                'changeRequestCreateRequest',
                'Required parameter "changeRequestCreateRequest" was null or undefined when calling createChangeRequestOnHumanMeanById().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['source'] != null) {
            queryParameters['source'] = requestParameters['source'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['contentType'] != null) {
            headerParameters['Content-Type'] = String(requestParameters['contentType']);
        }

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/human-means/{humanMeanId}/change-requests`;
        urlPath = urlPath.replace(`{${"humanMeanId"}}`, encodeURIComponent(String(requestParameters['humanMeanId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ChangeRequestCreateRequestToJSON(requestParameters['changeRequestCreateRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ChangeRequestFromJSON(jsonValue));
    }

    /**
     * ## Description  This endpoint allows the creation of a change request on a specific HumanMean resource, identified by its `HumanMeanId`.  The change request uses the JSON Patch format as specified in [RFC 6902](https://datatracker.ietf.org/doc/html/rfc6902), enabling clients to submit a set of operations to modify the HumanMean resource.  Client uers must have the provided `requestorMemberIdentifier` as part of their own member identifiers.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Update`. - **ACL Mode**: `WRITE` mode or above is required to create a change request on a HumanMean resource.   - **Note**: The `WRITE` mode is sufficient for creating change requests, but higher modes like `CONTROL` or `Admin` can also be used.   - With `CONTROL` mode, the change request will be automatically accepted and applied, updating the HumanMean resource.   - With `WRITE` mode, the change request will be created but not applied automatically. The change request must then be accepted or rejected using the `PATCH` method on the change request resource. 
     * Create a change request on a HumanMean
     */
    async createChangeRequestOnHumanMeanById(requestParameters: CreateChangeRequestOnHumanMeanByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ChangeRequest | null | undefined > {
        const response = await this.createChangeRequestOnHumanMeanByIdRaw(requestParameters, initOverrides);
        switch (response.raw.status) {
            case 201:
                return null;
            case 200:
                return await response.value();
            default:
                return await response.value();
        }
    }

    /**
     * ## Description  This endpoint allows the creation of a new HumanMean.  When creating a HumanMean, the value of the header `X-BOL-Member-Identifier` defines the HumanMean\'s owner. The Member Identifier must be a valid AD Entra ID Object ID of a Member that is part of the authenticated company user.  When creating a HumanMean, its ACL (Access Control List) is initialized with a default set of authorizations. The ACL defines which Members have access to the HumanMean and what actions they can perform.  By default, the ACL is initialized with access for the Member that creates the HumanMean, granting it `CONTROL` access mode. This means that the Member can manage the ACL and perform any operation on the HumanMean.  It is possible to use the header `X-BOL-ACL-authorizations` to specify additional authorizations for the ACL on initialization. The header must contain a JSON array of authorizations to apply in addition to the default one.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Create`. 
     * Create a HumanMean
     */
    async createHumanMeanRaw(requestParameters: CreateHumanMeanRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<HumanMeanResponse>> {
        if (requestParameters['contentType'] == null) {
            throw new runtime.RequiredError(
                'contentType',
                'Required parameter "contentType" was null or undefined when calling createHumanMean().'
            );
        }

        if (requestParameters['xBOLMemberIdentifier'] == null) {
            throw new runtime.RequiredError(
                'xBOLMemberIdentifier',
                'Required parameter "xBOLMemberIdentifier" was null or undefined when calling createHumanMean().'
            );
        }

        if (requestParameters['humanMean'] == null) {
            throw new runtime.RequiredError(
                'humanMean',
                'Required parameter "humanMean" was null or undefined when calling createHumanMean().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        if (requestParameters['source'] != null) {
            queryParameters['source'] = requestParameters['source'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['contentType'] != null) {
            headerParameters['Content-Type'] = String(requestParameters['contentType']);
        }

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (requestParameters['xBOLMemberIdentifier'] != null) {
            headerParameters['X-BOL-Member-Identifier'] = String(requestParameters['xBOLMemberIdentifier']);
        }

        if (requestParameters['xBOLACLAuthorizations'] != null) {
            headerParameters['X-BOL-ACL-authorizations'] = String(requestParameters['xBOLACLAuthorizations']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/human-means`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: HumanMeanToJSON(requestParameters['humanMean']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => HumanMeanResponseFromJSON(jsonValue));
    }

    /**
     * ## Description  This endpoint allows the creation of a new HumanMean.  When creating a HumanMean, the value of the header `X-BOL-Member-Identifier` defines the HumanMean\'s owner. The Member Identifier must be a valid AD Entra ID Object ID of a Member that is part of the authenticated company user.  When creating a HumanMean, its ACL (Access Control List) is initialized with a default set of authorizations. The ACL defines which Members have access to the HumanMean and what actions they can perform.  By default, the ACL is initialized with access for the Member that creates the HumanMean, granting it `CONTROL` access mode. This means that the Member can manage the ACL and perform any operation on the HumanMean.  It is possible to use the header `X-BOL-ACL-authorizations` to specify additional authorizations for the ACL on initialization. The header must contain a JSON array of authorizations to apply in addition to the default one.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Create`. 
     * Create a HumanMean
     */
    async createHumanMean(requestParameters: CreateHumanMeanRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<HumanMeanResponse | null | undefined > {
        const response = await this.createHumanMeanRaw(requestParameters, initOverrides);
        switch (response.raw.status) {
            case 201:
                return null;
            case 200:
                return await response.value();
            default:
                return await response.value();
        }
    }

    /**
     * ## Description  Create an Event of a HumanMean by `humanMeanId`.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Update`. - **ACL Mode**: `WRITE` mode is required to create an event on a HumanMean resource. 
     * Create an Event of a HumanMean
     */
    async createHumanMeanEventRaw(requestParameters: CreateHumanMeanEventRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['humanMeanId'] == null) {
            throw new runtime.RequiredError(
                'humanMeanId',
                'Required parameter "humanMeanId" was null or undefined when calling createHumanMeanEvent().'
            );
        }

        if (requestParameters['contentType'] == null) {
            throw new runtime.RequiredError(
                'contentType',
                'Required parameter "contentType" was null or undefined when calling createHumanMeanEvent().'
            );
        }

        if (requestParameters['xBOLMemberIdentifier'] == null) {
            throw new runtime.RequiredError(
                'xBOLMemberIdentifier',
                'Required parameter "xBOLMemberIdentifier" was null or undefined when calling createHumanMeanEvent().'
            );
        }

        if (requestParameters['eventCreateRequest'] == null) {
            throw new runtime.RequiredError(
                'eventCreateRequest',
                'Required parameter "eventCreateRequest" was null or undefined when calling createHumanMeanEvent().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['contentType'] != null) {
            headerParameters['Content-Type'] = String(requestParameters['contentType']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (requestParameters['xBOLMemberIdentifier'] != null) {
            headerParameters['X-BOL-Member-Identifier'] = String(requestParameters['xBOLMemberIdentifier']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/human-means/{humanMeanId}/events`;
        urlPath = urlPath.replace(`{${"humanMeanId"}}`, encodeURIComponent(String(requestParameters['humanMeanId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: EventCreateRequestToJSON(requestParameters['eventCreateRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * ## Description  Create an Event of a HumanMean by `humanMeanId`.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Update`. - **ACL Mode**: `WRITE` mode is required to create an event on a HumanMean resource. 
     * Create an Event of a HumanMean
     */
    async createHumanMeanEvent(requestParameters: CreateHumanMeanEventRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.createHumanMeanEventRaw(requestParameters, initOverrides);
    }

    /**
     * ## Description  This endpoint allows the deletion of a specific authorization from the Access Control List (ACL) of a HumanMean resource for a given member, identified by the `memberId`. This removes the access granted to the specified member for the Logistics Object.  - When an ACL authorization is deleted, the member will lose access to the HumanMean resource according to the authorization that was removed. - This operation should be performed with caution as it affects access control to the resource. - The requesting user must have sufficient privileges to modify the ACL.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Update`. - **ACL Mode**: `CONTROL` mode is required to delete authorizations from the ACL of a HumanMean resource. 
     * Delete an authorization of an access control list of a HumanMean by memberId
     */
    async deleteHumanMeanACLAuthorizationByMemberIdRaw(requestParameters: DeleteHumanMeanACLAuthorizationByMemberIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['humanMeanId'] == null) {
            throw new runtime.RequiredError(
                'humanMeanId',
                'Required parameter "humanMeanId" was null or undefined when calling deleteHumanMeanACLAuthorizationByMemberId().'
            );
        }

        if (requestParameters['memberId'] == null) {
            throw new runtime.RequiredError(
                'memberId',
                'Required parameter "memberId" was null or undefined when calling deleteHumanMeanACLAuthorizationByMemberId().'
            );
        }

        if (requestParameters['xBOLMemberIdentifier'] == null) {
            throw new runtime.RequiredError(
                'xBOLMemberIdentifier',
                'Required parameter "xBOLMemberIdentifier" was null or undefined when calling deleteHumanMeanACLAuthorizationByMemberId().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['aclRevision'] != null) {
            queryParameters['aclRevision'] = requestParameters['aclRevision'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (requestParameters['xBOLMemberIdentifier'] != null) {
            headerParameters['X-BOL-Member-Identifier'] = String(requestParameters['xBOLMemberIdentifier']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/human-means/{humanMeanId}/acl/authorizations/{memberId}`;
        urlPath = urlPath.replace(`{${"humanMeanId"}}`, encodeURIComponent(String(requestParameters['humanMeanId'])));
        urlPath = urlPath.replace(`{${"memberId"}}`, encodeURIComponent(String(requestParameters['memberId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * ## Description  This endpoint allows the deletion of a specific authorization from the Access Control List (ACL) of a HumanMean resource for a given member, identified by the `memberId`. This removes the access granted to the specified member for the Logistics Object.  - When an ACL authorization is deleted, the member will lose access to the HumanMean resource according to the authorization that was removed. - This operation should be performed with caution as it affects access control to the resource. - The requesting user must have sufficient privileges to modify the ACL.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Update`. - **ACL Mode**: `CONTROL` mode is required to delete authorizations from the ACL of a HumanMean resource. 
     * Delete an authorization of an access control list of a HumanMean by memberId
     */
    async deleteHumanMeanACLAuthorizationByMemberId(requestParameters: DeleteHumanMeanACLAuthorizationByMemberIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteHumanMeanACLAuthorizationByMemberIdRaw(requestParameters, initOverrides);
    }

    /**
     * ## Description  This endpoint allows the deletion of a specific HumanMean resource, identified by its `HumanMeanId`.  - When a HumanMean is deleted, it is permanently removed from the system and cannot be recovered. This operation should be performed with caution. - Deletion of a HumanMean resource is allowed even if the resource is referenced by any other resources or if the references are also deleted. - Deleting a HumanMean resource also deletes any associated change requests and metadata, including the ACL and authorizations, as well as all Logistics Object Events.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Delete`. - **ACL Mode**: `CONTROL` mode is required to delete a HumanMean resource. 
     * Delete a HumanMean by humanMeanId
     */
    async deleteHumanMeanByIdRaw(requestParameters: DeleteHumanMeanByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['humanMeanId'] == null) {
            throw new runtime.RequiredError(
                'humanMeanId',
                'Required parameter "humanMeanId" was null or undefined when calling deleteHumanMeanById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/human-means/{humanMeanId}`;
        urlPath = urlPath.replace(`{${"humanMeanId"}}`, encodeURIComponent(String(requestParameters['humanMeanId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * ## Description  This endpoint allows the deletion of a specific HumanMean resource, identified by its `HumanMeanId`.  - When a HumanMean is deleted, it is permanently removed from the system and cannot be recovered. This operation should be performed with caution. - Deletion of a HumanMean resource is allowed even if the resource is referenced by any other resources or if the references are also deleted. - Deleting a HumanMean resource also deletes any associated change requests and metadata, including the ACL and authorizations, as well as all Logistics Object Events.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Delete`. - **ACL Mode**: `CONTROL` mode is required to delete a HumanMean resource. 
     * Delete a HumanMean by humanMeanId
     */
    async deleteHumanMeanById(requestParameters: DeleteHumanMeanByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteHumanMeanByIdRaw(requestParameters, initOverrides);
    }

    /**
     * ## Description  This endpoint allows the deletion of a specific event of a HumanMean resource by its `eventId`.  ## Access Control  - **AD Entra ID Role**: Requires the custom role \'BOL.LOGISTICS-OBJECTS.Update\'. - **ACL Mode**: `CONTROL` mode is required to delete an event of a HumanMean resource. 
     * Delete an event of a HumanMean by id
     */
    async deleteHumanMeanEventByIdRaw(requestParameters: DeleteHumanMeanEventByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['humanMeanId'] == null) {
            throw new runtime.RequiredError(
                'humanMeanId',
                'Required parameter "humanMeanId" was null or undefined when calling deleteHumanMeanEventById().'
            );
        }

        if (requestParameters['eventId'] == null) {
            throw new runtime.RequiredError(
                'eventId',
                'Required parameter "eventId" was null or undefined when calling deleteHumanMeanEventById().'
            );
        }

        if (requestParameters['xBOLMemberIdentifier'] == null) {
            throw new runtime.RequiredError(
                'xBOLMemberIdentifier',
                'Required parameter "xBOLMemberIdentifier" was null or undefined when calling deleteHumanMeanEventById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (requestParameters['xBOLMemberIdentifier'] != null) {
            headerParameters['X-BOL-Member-Identifier'] = String(requestParameters['xBOLMemberIdentifier']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/human-means/{humanMeanId}/events/{eventId}`;
        urlPath = urlPath.replace(`{${"humanMeanId"}}`, encodeURIComponent(String(requestParameters['humanMeanId'])));
        urlPath = urlPath.replace(`{${"eventId"}}`, encodeURIComponent(String(requestParameters['eventId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * ## Description  This endpoint allows the deletion of a specific event of a HumanMean resource by its `eventId`.  ## Access Control  - **AD Entra ID Role**: Requires the custom role \'BOL.LOGISTICS-OBJECTS.Update\'. - **ACL Mode**: `CONTROL` mode is required to delete an event of a HumanMean resource. 
     * Delete an event of a HumanMean by id
     */
    async deleteHumanMeanEventById(requestParameters: DeleteHumanMeanEventByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteHumanMeanEventByIdRaw(requestParameters, initOverrides);
    }

    /**
     * ## Description  Retrieves a specific ChangeRequest associated with a given HumanMean, identified by its `changeRequestId`. This endpoint allows clients to access the details and status of a particular change request, including the set of modifications proposed or applied to the HumanMean resource.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access the details of a ChangeRequest resource. 
     * Get a change request on a HumanMean by changeRequestId
     */
    async getChangeRequestOnHumanMeanByIdRaw(requestParameters: GetChangeRequestOnHumanMeanByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ChangeRequest>> {
        if (requestParameters['humanMeanId'] == null) {
            throw new runtime.RequiredError(
                'humanMeanId',
                'Required parameter "humanMeanId" was null or undefined when calling getChangeRequestOnHumanMeanById().'
            );
        }

        if (requestParameters['changeRequestId'] == null) {
            throw new runtime.RequiredError(
                'changeRequestId',
                'Required parameter "changeRequestId" was null or undefined when calling getChangeRequestOnHumanMeanById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/human-means/{humanMeanId}/change-requests/{changeRequestId}`;
        urlPath = urlPath.replace(`{${"humanMeanId"}}`, encodeURIComponent(String(requestParameters['humanMeanId'])));
        urlPath = urlPath.replace(`{${"changeRequestId"}}`, encodeURIComponent(String(requestParameters['changeRequestId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ChangeRequestFromJSON(jsonValue));
    }

    /**
     * ## Description  Retrieves a specific ChangeRequest associated with a given HumanMean, identified by its `changeRequestId`. This endpoint allows clients to access the details and status of a particular change request, including the set of modifications proposed or applied to the HumanMean resource.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access the details of a ChangeRequest resource. 
     * Get a change request on a HumanMean by changeRequestId
     */
    async getChangeRequestOnHumanMeanById(requestParameters: GetChangeRequestOnHumanMeanByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ChangeRequest> {
        const response = await this.getChangeRequestOnHumanMeanByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ## Description  This endpoint retrieves a specific authorization from the Access Control List (ACL) of a HumanMean resource for a given member, identified by the `memberId`. This allows clients to check the specific access mode granted to a particular member for the Logistics Object.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access the ACL authorization of a HumanMean resource. - **Note**: Only the `CONTROL` mode allows to get any member authorization. In `READ`, `WRITE` modes, only the authorization for the authenticated member user can be retrieved. 
     * Get an authorization of an access control list of a HumanMean by memberId
     */
    async getHumanMeanACLAuthorizationByMemberIdRaw(requestParameters: GetHumanMeanACLAuthorizationByMemberIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ACLAuthorization>> {
        if (requestParameters['humanMeanId'] == null) {
            throw new runtime.RequiredError(
                'humanMeanId',
                'Required parameter "humanMeanId" was null or undefined when calling getHumanMeanACLAuthorizationByMemberId().'
            );
        }

        if (requestParameters['memberId'] == null) {
            throw new runtime.RequiredError(
                'memberId',
                'Required parameter "memberId" was null or undefined when calling getHumanMeanACLAuthorizationByMemberId().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['at'] != null) {
            queryParameters['at'] = requestParameters['at'];
        }

        if (requestParameters['aclRevision'] != null) {
            queryParameters['aclRevision'] = requestParameters['aclRevision'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/human-means/{humanMeanId}/acl/authorizations/{memberId}`;
        urlPath = urlPath.replace(`{${"humanMeanId"}}`, encodeURIComponent(String(requestParameters['humanMeanId'])));
        urlPath = urlPath.replace(`{${"memberId"}}`, encodeURIComponent(String(requestParameters['memberId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ACLAuthorizationFromJSON(jsonValue));
    }

    /**
     * ## Description  This endpoint retrieves a specific authorization from the Access Control List (ACL) of a HumanMean resource for a given member, identified by the `memberId`. This allows clients to check the specific access mode granted to a particular member for the Logistics Object.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access the ACL authorization of a HumanMean resource. - **Note**: Only the `CONTROL` mode allows to get any member authorization. In `READ`, `WRITE` modes, only the authorization for the authenticated member user can be retrieved. 
     * Get an authorization of an access control list of a HumanMean by memberId
     */
    async getHumanMeanACLAuthorizationByMemberId(requestParameters: GetHumanMeanACLAuthorizationByMemberIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ACLAuthorization> {
        const response = await this.getHumanMeanACLAuthorizationByMemberIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ## Description  Retrieves the Access Control List (ACL) for a specific HumanMean resource, identified by its `HumanMeanId`. The ACL details the authorizations for the authenticated member user.  This endpoint enables clients to review which members have access to the HumanMean and under which access modes, supporting fine-grained authorization.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access the ACL of a HumanMean resource. - **Note**: Only the `CONTROL` mode allows to get the Logistics Object ACL with all authorizations. In `READ`, `WRITE`, `READ` mode, the ACL will only contain authorizations for the authenticated member user. 
     * Get ACL of a HumanMean for the authenticated member user. The ACL with the latest revision is returned by default.
     */
    async getHumanMeanACLByIdRaw(requestParameters: GetHumanMeanACLByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ACL>> {
        if (requestParameters['humanMeanId'] == null) {
            throw new runtime.RequiredError(
                'humanMeanId',
                'Required parameter "humanMeanId" was null or undefined when calling getHumanMeanACLById().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['at'] != null) {
            queryParameters['at'] = requestParameters['at'];
        }

        if (requestParameters['revision'] != null) {
            queryParameters['revision'] = requestParameters['revision'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/human-means/{humanMeanId}/acl`;
        urlPath = urlPath.replace(`{${"humanMeanId"}}`, encodeURIComponent(String(requestParameters['humanMeanId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ACLFromJSON(jsonValue));
    }

    /**
     * ## Description  Retrieves the Access Control List (ACL) for a specific HumanMean resource, identified by its `HumanMeanId`. The ACL details the authorizations for the authenticated member user.  This endpoint enables clients to review which members have access to the HumanMean and under which access modes, supporting fine-grained authorization.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access the ACL of a HumanMean resource. - **Note**: Only the `CONTROL` mode allows to get the Logistics Object ACL with all authorizations. In `READ`, `WRITE`, `READ` mode, the ACL will only contain authorizations for the authenticated member user. 
     * Get ACL of a HumanMean for the authenticated member user. The ACL with the latest revision is returned by default.
     */
    async getHumanMeanACLById(requestParameters: GetHumanMeanACLByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ACL> {
        const response = await this.getHumanMeanACLByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ## Description  This endpoint retrieves a specific HumanMean by its `HumanMeanId`.  __Note:__ The `revision` and `at` query parameters cannot be used at the same time. If both are provided simultaneously, the request will result in a `Bad Request` error.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access this HumanMean resource. 
     * Get a HumanMean by humanMeanId
     */
    async getHumanMeanByIdRaw(requestParameters: GetHumanMeanByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<HumanMeanResponse>> {
        if (requestParameters['humanMeanId'] == null) {
            throw new runtime.RequiredError(
                'humanMeanId',
                'Required parameter "humanMeanId" was null or undefined when calling getHumanMeanById().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['at'] != null) {
            queryParameters['at'] = requestParameters['at'];
        }

        if (requestParameters['revision'] != null) {
            queryParameters['revision'] = requestParameters['revision'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/human-means/{humanMeanId}`;
        urlPath = urlPath.replace(`{${"humanMeanId"}}`, encodeURIComponent(String(requestParameters['humanMeanId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => HumanMeanResponseFromJSON(jsonValue));
    }

    /**
     * ## Description  This endpoint retrieves a specific HumanMean by its `HumanMeanId`.  __Note:__ The `revision` and `at` query parameters cannot be used at the same time. If both are provided simultaneously, the request will result in a `Bad Request` error.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access this HumanMean resource. 
     * Get a HumanMean by humanMeanId
     */
    async getHumanMeanById(requestParameters: GetHumanMeanByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<HumanMeanResponse> {
        const response = await this.getHumanMeanByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ## Description  List Events of a HumanMean by `humanMeanId`, ordered by their `actualDateTime`, from newest to oldest. Events are returned in a paginated format.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access the events of a HumanMean resource. 
     * List Events of a HumanMean
     */
    async getHumanMeanEventsRaw(requestParameters: GetHumanMeanEventsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedEvents>> {
        if (requestParameters['humanMeanId'] == null) {
            throw new runtime.RequiredError(
                'humanMeanId',
                'Required parameter "humanMeanId" was null or undefined when calling getHumanMeanEvents().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        if (requestParameters['startAt'] != null) {
            queryParameters['startAt'] = requestParameters['startAt'];
        }

        if (requestParameters['endAt'] != null) {
            queryParameters['endAt'] = requestParameters['endAt'];
        }

        if (requestParameters['code'] != null) {
            queryParameters['code'] = requestParameters['code'];
        }

        if (requestParameters['type'] != null) {
            queryParameters['type'] = requestParameters['type'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/human-means/{humanMeanId}/events`;
        urlPath = urlPath.replace(`{${"humanMeanId"}}`, encodeURIComponent(String(requestParameters['humanMeanId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedEventsFromJSON(jsonValue));
    }

    /**
     * ## Description  List Events of a HumanMean by `humanMeanId`, ordered by their `actualDateTime`, from newest to oldest. Events are returned in a paginated format.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access the events of a HumanMean resource. 
     * List Events of a HumanMean
     */
    async getHumanMeanEvents(requestParameters: GetHumanMeanEventsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedEvents> {
        const response = await this.getHumanMeanEventsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ## Description  This endpoint retrieves the metadata of a specific HumanMean by its `HumanMeanId`.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access this resource. 
     * Get a HumanMean metadata by humanMeanId
     */
    async getHumanMeanMetadataByIdRaw(requestParameters: GetHumanMeanMetadataByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LogisticsObjectMetadata>> {
        if (requestParameters['humanMeanId'] == null) {
            throw new runtime.RequiredError(
                'humanMeanId',
                'Required parameter "humanMeanId" was null or undefined when calling getHumanMeanMetadataById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/human-means/{humanMeanId}/metadata`;
        urlPath = urlPath.replace(`{${"humanMeanId"}}`, encodeURIComponent(String(requestParameters['humanMeanId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LogisticsObjectMetadataFromJSON(jsonValue));
    }

    /**
     * ## Description  This endpoint retrieves the metadata of a specific HumanMean by its `HumanMeanId`.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access this resource. 
     * Get a HumanMean metadata by humanMeanId
     */
    async getHumanMeanMetadataById(requestParameters: GetHumanMeanMetadataByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LogisticsObjectMetadata> {
        const response = await this.getHumanMeanMetadataByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ## Description  Retrieves a list of all change requests associated with the specified HumanMean, identified by its `HumanMeanId`. This endpoint allows clients to review the history of change requests (such as updates or modifications) that have been submitted for a given HumanMean resource.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access the list of change requests for a HumanMean resource. 
     * Get a list of ChangeRequest for HumanMean
     */
    async listChangeRequestsOfHumanMeanByIdRaw(requestParameters: ListChangeRequestsOfHumanMeanByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedChangeRequests>> {
        if (requestParameters['humanMeanId'] == null) {
            throw new runtime.RequiredError(
                'humanMeanId',
                'Required parameter "humanMeanId" was null or undefined when calling listChangeRequestsOfHumanMeanById().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/human-means/{humanMeanId}/change-requests`;
        urlPath = urlPath.replace(`{${"humanMeanId"}}`, encodeURIComponent(String(requestParameters['humanMeanId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedChangeRequestsFromJSON(jsonValue));
    }

    /**
     * ## Description  Retrieves a list of all change requests associated with the specified HumanMean, identified by its `HumanMeanId`. This endpoint allows clients to review the history of change requests (such as updates or modifications) that have been submitted for a given HumanMean resource.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access the list of change requests for a HumanMean resource. 
     * Get a list of ChangeRequest for HumanMean
     */
    async listChangeRequestsOfHumanMeanById(requestParameters: ListChangeRequestsOfHumanMeanByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedChangeRequests> {
        const response = await this.listChangeRequestsOfHumanMeanByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ## Description  This endpoint allows updating an existing HumanMean identified by its `HumanMeanId` using JSON Merge Patch as specified in [RFC 7396](https://datatracker.ietf.org/doc/html/rfc7396). The patch operation applies partial updates to the resource. The underlying mechanism is the creation of a change-request, which will then be automatically accepted and applied.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Update`. - **ACL Mode**: `CONTROL` mode is required to create a change request on a HumanMean resource. 
     * Partially update a HumanMean by applying a JSON Merge Patch change request
     */
    async patchHumanMeanByIdRaw(requestParameters: PatchHumanMeanByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<HumanMeanResponse>> {
        if (requestParameters['humanMeanId'] == null) {
            throw new runtime.RequiredError(
                'humanMeanId',
                'Required parameter "humanMeanId" was null or undefined when calling patchHumanMeanById().'
            );
        }

        if (requestParameters['contentType'] == null) {
            throw new runtime.RequiredError(
                'contentType',
                'Required parameter "contentType" was null or undefined when calling patchHumanMeanById().'
            );
        }

        if (requestParameters['xBOLMemberIdentifier'] == null) {
            throw new runtime.RequiredError(
                'xBOLMemberIdentifier',
                'Required parameter "xBOLMemberIdentifier" was null or undefined when calling patchHumanMeanById().'
            );
        }

        if (requestParameters['humanMean'] == null) {
            throw new runtime.RequiredError(
                'humanMean',
                'Required parameter "humanMean" was null or undefined when calling patchHumanMeanById().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['revision'] != null) {
            queryParameters['revision'] = requestParameters['revision'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['contentType'] != null) {
            headerParameters['Content-Type'] = String(requestParameters['contentType']);
        }

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (requestParameters['xBOLMemberIdentifier'] != null) {
            headerParameters['X-BOL-Member-Identifier'] = String(requestParameters['xBOLMemberIdentifier']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/human-means/{humanMeanId}`;
        urlPath = urlPath.replace(`{${"humanMeanId"}}`, encodeURIComponent(String(requestParameters['humanMeanId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: HumanMeanToJSON(requestParameters['humanMean']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => HumanMeanResponseFromJSON(jsonValue));
    }

    /**
     * ## Description  This endpoint allows updating an existing HumanMean identified by its `HumanMeanId` using JSON Merge Patch as specified in [RFC 7396](https://datatracker.ietf.org/doc/html/rfc7396). The patch operation applies partial updates to the resource. The underlying mechanism is the creation of a change-request, which will then be automatically accepted and applied.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Update`. - **ACL Mode**: `CONTROL` mode is required to create a change request on a HumanMean resource. 
     * Partially update a HumanMean by applying a JSON Merge Patch change request
     */
    async patchHumanMeanById(requestParameters: PatchHumanMeanByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<HumanMeanResponse> {
        const response = await this.patchHumanMeanByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ## Description  Retrieves a paginated list of HumanMean resources matching the specified search and filter criteria. This endpoint enables clients to perform advanced queries on HumanMeans.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access the list of HumanMean resources. 
     * Search for HumanMeans
     */
    async searchHumanMeanGetRaw(requestParameters: SearchHumanMeanGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SearchHumanMeansResponse>> {
        const queryParameters: any = {};

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        if (requestParameters['searchBody'] != null) {
            queryParameters['searchBody'] = requestParameters['searchBody'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/human-means/search`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SearchHumanMeansResponseFromJSON(jsonValue));
    }

    /**
     * ## Description  Retrieves a paginated list of HumanMean resources matching the specified search and filter criteria. This endpoint enables clients to perform advanced queries on HumanMeans.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access the list of HumanMean resources. 
     * Search for HumanMeans
     */
    async searchHumanMeanGet(requestParameters: SearchHumanMeanGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SearchHumanMeansResponse> {
        const response = await this.searchHumanMeanGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ## Description  Retrieves a paginated list of HumanMean resources matching the specified search and filter criteria. This endpoint enables clients to perform advanced queries on HumanMeans.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access the list of HumanMean resources. 
     * Search for HumanMeans
     */
    async searchHumanMeansPostRaw(requestParameters: SearchHumanMeansPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SearchHumanMeansResponse>> {
        if (requestParameters['contentType'] == null) {
            throw new runtime.RequiredError(
                'contentType',
                'Required parameter "contentType" was null or undefined when calling searchHumanMeansPost().'
            );
        }

        if (requestParameters['searchHumanMeansRequest'] == null) {
            throw new runtime.RequiredError(
                'searchHumanMeansRequest',
                'Required parameter "searchHumanMeansRequest" was null or undefined when calling searchHumanMeansPost().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['contentType'] != null) {
            headerParameters['Content-Type'] = String(requestParameters['contentType']);
        }

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/human-means/search`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SearchHumanMeansRequestToJSON(requestParameters['searchHumanMeansRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SearchHumanMeansResponseFromJSON(jsonValue));
    }

    /**
     * ## Description  Retrieves a paginated list of HumanMean resources matching the specified search and filter criteria. This endpoint enables clients to perform advanced queries on HumanMeans.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access the list of HumanMean resources. 
     * Search for HumanMeans
     */
    async searchHumanMeansPost(requestParameters: SearchHumanMeansPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SearchHumanMeansResponse> {
        const response = await this.searchHumanMeansPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ## Description  This endpoint allows you to accept or reject a specific ChangeRequest associated with a given HumanMean, using JSON Merge Patch as specified in [RFC 7396](https://datatracker.ietf.org/doc/html/rfc7396). It enables clients to update the status or details of a ChangeRequest, such as marking it as accepted or rejected, and to apply partial modifications to the resource.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Write`. - **ACL Mode**: `CONTROL` mode is required to accept or reject a ChangeRequest on a HumanMean resource. 
     * Accept or reject a ChangeRequest on a  HumanMean using JSON Merge Patch as specified in [RFC 7396](https://datatracker.ietf.org/doc/html/rfc7396).
     */
    async updateChangeRequestOnHumanMeanByIdRaw(requestParameters: UpdateChangeRequestOnHumanMeanByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ChangeRequest>> {
        if (requestParameters['humanMeanId'] == null) {
            throw new runtime.RequiredError(
                'humanMeanId',
                'Required parameter "humanMeanId" was null or undefined when calling updateChangeRequestOnHumanMeanById().'
            );
        }

        if (requestParameters['changeRequestId'] == null) {
            throw new runtime.RequiredError(
                'changeRequestId',
                'Required parameter "changeRequestId" was null or undefined when calling updateChangeRequestOnHumanMeanById().'
            );
        }

        if (requestParameters['contentType'] == null) {
            throw new runtime.RequiredError(
                'contentType',
                'Required parameter "contentType" was null or undefined when calling updateChangeRequestOnHumanMeanById().'
            );
        }

        if (requestParameters['changeRequestPatchRequest'] == null) {
            throw new runtime.RequiredError(
                'changeRequestPatchRequest',
                'Required parameter "changeRequestPatchRequest" was null or undefined when calling updateChangeRequestOnHumanMeanById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['contentType'] != null) {
            headerParameters['Content-Type'] = String(requestParameters['contentType']);
        }

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/human-means/{humanMeanId}/change-requests/{changeRequestId}`;
        urlPath = urlPath.replace(`{${"humanMeanId"}}`, encodeURIComponent(String(requestParameters['humanMeanId'])));
        urlPath = urlPath.replace(`{${"changeRequestId"}}`, encodeURIComponent(String(requestParameters['changeRequestId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: ChangeRequestPatchRequestToJSON(requestParameters['changeRequestPatchRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ChangeRequestFromJSON(jsonValue));
    }

    /**
     * ## Description  This endpoint allows you to accept or reject a specific ChangeRequest associated with a given HumanMean, using JSON Merge Patch as specified in [RFC 7396](https://datatracker.ietf.org/doc/html/rfc7396). It enables clients to update the status or details of a ChangeRequest, such as marking it as accepted or rejected, and to apply partial modifications to the resource.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Write`. - **ACL Mode**: `CONTROL` mode is required to accept or reject a ChangeRequest on a HumanMean resource. 
     * Accept or reject a ChangeRequest on a  HumanMean using JSON Merge Patch as specified in [RFC 7396](https://datatracker.ietf.org/doc/html/rfc7396).
     */
    async updateChangeRequestOnHumanMeanById(requestParameters: UpdateChangeRequestOnHumanMeanByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ChangeRequest> {
        const response = await this.updateChangeRequestOnHumanMeanByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ## Description  This endpoint allows updating an existing HumanMean identified by its `HumanMeanId`. The underlying mechanism is the creation of a change request, which will then be automatically accepted and applied.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Update`. - **ACL Mode**: `CONTROL` mode is required to create a change request on a HumanMean resource. 
     * Update an existing HumanMean by creating and applying a change request
     */
    async updateHumanMeanByIdRaw(requestParameters: UpdateHumanMeanByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<HumanMeanResponse>> {
        if (requestParameters['humanMeanId'] == null) {
            throw new runtime.RequiredError(
                'humanMeanId',
                'Required parameter "humanMeanId" was null or undefined when calling updateHumanMeanById().'
            );
        }

        if (requestParameters['contentType'] == null) {
            throw new runtime.RequiredError(
                'contentType',
                'Required parameter "contentType" was null or undefined when calling updateHumanMeanById().'
            );
        }

        if (requestParameters['xBOLMemberIdentifier'] == null) {
            throw new runtime.RequiredError(
                'xBOLMemberIdentifier',
                'Required parameter "xBOLMemberIdentifier" was null or undefined when calling updateHumanMeanById().'
            );
        }

        if (requestParameters['humanMean'] == null) {
            throw new runtime.RequiredError(
                'humanMean',
                'Required parameter "humanMean" was null or undefined when calling updateHumanMeanById().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['revision'] != null) {
            queryParameters['revision'] = requestParameters['revision'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['contentType'] != null) {
            headerParameters['Content-Type'] = String(requestParameters['contentType']);
        }

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (requestParameters['xBOLMemberIdentifier'] != null) {
            headerParameters['X-BOL-Member-Identifier'] = String(requestParameters['xBOLMemberIdentifier']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/human-means/{humanMeanId}`;
        urlPath = urlPath.replace(`{${"humanMeanId"}}`, encodeURIComponent(String(requestParameters['humanMeanId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: HumanMeanToJSON(requestParameters['humanMean']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => HumanMeanResponseFromJSON(jsonValue));
    }

    /**
     * ## Description  This endpoint allows updating an existing HumanMean identified by its `HumanMeanId`. The underlying mechanism is the creation of a change request, which will then be automatically accepted and applied.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Update`. - **ACL Mode**: `CONTROL` mode is required to create a change request on a HumanMean resource. 
     * Update an existing HumanMean by creating and applying a change request
     */
    async updateHumanMeanById(requestParameters: UpdateHumanMeanByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<HumanMeanResponse> {
        const response = await this.updateHumanMeanByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ## Description  This endpoint allows clients to create or update an authorization in the Access Control List (ACL) of a specific HumanMean resource, identified by its `HumanMeanId`.  If an authorization already exists for the given `memberIdentifier`, then this authorization is replaced by this requested new authorization.  The value of the header `X-BOL-Member-Identifier` defines the member that authorized the access. The Member Identifier must be a valid AD Entra ID Object ID of a Member that is part of the authenticated company user.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Update`. - **ACL Mode**: `CONTROL` mode is required to add or update authorizations in the ACL of a HumanMean resource. 
     * Upsert (create or update) an authorization of an access control list of a HumanMean.
     */
    async upsertHumanMeanACLAuthorizationByIdRaw(requestParameters: UpsertHumanMeanACLAuthorizationByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ACLAuthorization>> {
        if (requestParameters['humanMeanId'] == null) {
            throw new runtime.RequiredError(
                'humanMeanId',
                'Required parameter "humanMeanId" was null or undefined when calling upsertHumanMeanACLAuthorizationById().'
            );
        }

        if (requestParameters['contentType'] == null) {
            throw new runtime.RequiredError(
                'contentType',
                'Required parameter "contentType" was null or undefined when calling upsertHumanMeanACLAuthorizationById().'
            );
        }

        if (requestParameters['xBOLMemberIdentifier'] == null) {
            throw new runtime.RequiredError(
                'xBOLMemberIdentifier',
                'Required parameter "xBOLMemberIdentifier" was null or undefined when calling upsertHumanMeanACLAuthorizationById().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['aclRevision'] != null) {
            queryParameters['aclRevision'] = requestParameters['aclRevision'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['contentType'] != null) {
            headerParameters['Content-Type'] = String(requestParameters['contentType']);
        }

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (requestParameters['xBOLMemberIdentifier'] != null) {
            headerParameters['X-BOL-Member-Identifier'] = String(requestParameters['xBOLMemberIdentifier']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/human-means/{humanMeanId}/acl/authorizations`;
        urlPath = urlPath.replace(`{${"humanMeanId"}}`, encodeURIComponent(String(requestParameters['humanMeanId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ACLAuthorizationRequestToJSON(requestParameters['aCLAuthorizationRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ACLAuthorizationFromJSON(jsonValue));
    }

    /**
     * ## Description  This endpoint allows clients to create or update an authorization in the Access Control List (ACL) of a specific HumanMean resource, identified by its `HumanMeanId`.  If an authorization already exists for the given `memberIdentifier`, then this authorization is replaced by this requested new authorization.  The value of the header `X-BOL-Member-Identifier` defines the member that authorized the access. The Member Identifier must be a valid AD Entra ID Object ID of a Member that is part of the authenticated company user.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Update`. - **ACL Mode**: `CONTROL` mode is required to add or update authorizations in the ACL of a HumanMean resource. 
     * Upsert (create or update) an authorization of an access control list of a HumanMean.
     */
    async upsertHumanMeanACLAuthorizationById(requestParameters: UpsertHumanMeanACLAuthorizationByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ACLAuthorization> {
        const response = await this.upsertHumanMeanACLAuthorizationByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const CreateChangeRequestOnHumanMeanByIdContentTypeEnum = {
    ApplicationJson: 'application/json'
} as const;
export type CreateChangeRequestOnHumanMeanByIdContentTypeEnum = typeof CreateChangeRequestOnHumanMeanByIdContentTypeEnum[keyof typeof CreateChangeRequestOnHumanMeanByIdContentTypeEnum];
/**
 * @export
 */
export const CreateChangeRequestOnHumanMeanByIdAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type CreateChangeRequestOnHumanMeanByIdAcceptEnum = typeof CreateChangeRequestOnHumanMeanByIdAcceptEnum[keyof typeof CreateChangeRequestOnHumanMeanByIdAcceptEnum];
/**
 * @export
 */
export const CreateHumanMeanContentTypeEnum = {
    ApplicationJson: 'application/json'
} as const;
export type CreateHumanMeanContentTypeEnum = typeof CreateHumanMeanContentTypeEnum[keyof typeof CreateHumanMeanContentTypeEnum];
/**
 * @export
 */
export const CreateHumanMeanAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type CreateHumanMeanAcceptEnum = typeof CreateHumanMeanAcceptEnum[keyof typeof CreateHumanMeanAcceptEnum];
/**
 * @export
 */
export const CreateHumanMeanEventContentTypeEnum = {
    ApplicationJson: 'application/json'
} as const;
export type CreateHumanMeanEventContentTypeEnum = typeof CreateHumanMeanEventContentTypeEnum[keyof typeof CreateHumanMeanEventContentTypeEnum];
/**
 * @export
 */
export const CreateHumanMeanEventAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type CreateHumanMeanEventAcceptEnum = typeof CreateHumanMeanEventAcceptEnum[keyof typeof CreateHumanMeanEventAcceptEnum];
/**
 * @export
 */
export const GetChangeRequestOnHumanMeanByIdAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type GetChangeRequestOnHumanMeanByIdAcceptEnum = typeof GetChangeRequestOnHumanMeanByIdAcceptEnum[keyof typeof GetChangeRequestOnHumanMeanByIdAcceptEnum];
/**
 * @export
 */
export const GetHumanMeanACLAuthorizationByMemberIdAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type GetHumanMeanACLAuthorizationByMemberIdAcceptEnum = typeof GetHumanMeanACLAuthorizationByMemberIdAcceptEnum[keyof typeof GetHumanMeanACLAuthorizationByMemberIdAcceptEnum];
/**
 * @export
 */
export const GetHumanMeanACLByIdAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type GetHumanMeanACLByIdAcceptEnum = typeof GetHumanMeanACLByIdAcceptEnum[keyof typeof GetHumanMeanACLByIdAcceptEnum];
/**
 * @export
 */
export const GetHumanMeanByIdAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type GetHumanMeanByIdAcceptEnum = typeof GetHumanMeanByIdAcceptEnum[keyof typeof GetHumanMeanByIdAcceptEnum];
/**
 * @export
 */
export const GetHumanMeanEventsAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type GetHumanMeanEventsAcceptEnum = typeof GetHumanMeanEventsAcceptEnum[keyof typeof GetHumanMeanEventsAcceptEnum];
/**
 * @export
 */
export const GetHumanMeanMetadataByIdAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type GetHumanMeanMetadataByIdAcceptEnum = typeof GetHumanMeanMetadataByIdAcceptEnum[keyof typeof GetHumanMeanMetadataByIdAcceptEnum];
/**
 * @export
 */
export const ListChangeRequestsOfHumanMeanByIdAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type ListChangeRequestsOfHumanMeanByIdAcceptEnum = typeof ListChangeRequestsOfHumanMeanByIdAcceptEnum[keyof typeof ListChangeRequestsOfHumanMeanByIdAcceptEnum];
/**
 * @export
 */
export const PatchHumanMeanByIdContentTypeEnum = {
    ApplicationJson: 'application/json'
} as const;
export type PatchHumanMeanByIdContentTypeEnum = typeof PatchHumanMeanByIdContentTypeEnum[keyof typeof PatchHumanMeanByIdContentTypeEnum];
/**
 * @export
 */
export const PatchHumanMeanByIdAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type PatchHumanMeanByIdAcceptEnum = typeof PatchHumanMeanByIdAcceptEnum[keyof typeof PatchHumanMeanByIdAcceptEnum];
/**
 * @export
 */
export const SearchHumanMeanGetAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type SearchHumanMeanGetAcceptEnum = typeof SearchHumanMeanGetAcceptEnum[keyof typeof SearchHumanMeanGetAcceptEnum];
/**
 * @export
 */
export const SearchHumanMeansPostContentTypeEnum = {
    ApplicationJson: 'application/json'
} as const;
export type SearchHumanMeansPostContentTypeEnum = typeof SearchHumanMeansPostContentTypeEnum[keyof typeof SearchHumanMeansPostContentTypeEnum];
/**
 * @export
 */
export const SearchHumanMeansPostAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type SearchHumanMeansPostAcceptEnum = typeof SearchHumanMeansPostAcceptEnum[keyof typeof SearchHumanMeansPostAcceptEnum];
/**
 * @export
 */
export const UpdateChangeRequestOnHumanMeanByIdContentTypeEnum = {
    ApplicationJson: 'application/json'
} as const;
export type UpdateChangeRequestOnHumanMeanByIdContentTypeEnum = typeof UpdateChangeRequestOnHumanMeanByIdContentTypeEnum[keyof typeof UpdateChangeRequestOnHumanMeanByIdContentTypeEnum];
/**
 * @export
 */
export const UpdateChangeRequestOnHumanMeanByIdAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type UpdateChangeRequestOnHumanMeanByIdAcceptEnum = typeof UpdateChangeRequestOnHumanMeanByIdAcceptEnum[keyof typeof UpdateChangeRequestOnHumanMeanByIdAcceptEnum];
/**
 * @export
 */
export const UpdateHumanMeanByIdContentTypeEnum = {
    ApplicationJson: 'application/json'
} as const;
export type UpdateHumanMeanByIdContentTypeEnum = typeof UpdateHumanMeanByIdContentTypeEnum[keyof typeof UpdateHumanMeanByIdContentTypeEnum];
/**
 * @export
 */
export const UpdateHumanMeanByIdAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type UpdateHumanMeanByIdAcceptEnum = typeof UpdateHumanMeanByIdAcceptEnum[keyof typeof UpdateHumanMeanByIdAcceptEnum];
/**
 * @export
 */
export const UpsertHumanMeanACLAuthorizationByIdContentTypeEnum = {
    ApplicationJson: 'application/json'
} as const;
export type UpsertHumanMeanACLAuthorizationByIdContentTypeEnum = typeof UpsertHumanMeanACLAuthorizationByIdContentTypeEnum[keyof typeof UpsertHumanMeanACLAuthorizationByIdContentTypeEnum];
/**
 * @export
 */
export const UpsertHumanMeanACLAuthorizationByIdAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type UpsertHumanMeanACLAuthorizationByIdAcceptEnum = typeof UpsertHumanMeanACLAuthorizationByIdAcceptEnum[keyof typeof UpsertHumanMeanACLAuthorizationByIdAcceptEnum];
